import {useEffect} from 'react';
import {withRouter} from 'react-router-dom';

/**
 * @return {null}
 */
function ScrollToTop({history}) {
    useEffect(() => {
        setTimeout(() => window.scroll({top: 0, left: 0, behavior: 'smooth'}), 100);

        const unlisten = history.listen(() => {
            window.scrollTo(0, 0);
        });
        return () => {
            unlisten()
        }
    }, [history]);

    return null;
}

export default withRouter(ScrollToTop);
